module.exports = __webpack_public_path__ + "img/logo.2f0751ca.png";